<section class="thread-todo"
         [class.thread-todo--light]="lightTheme"
         [class.thread-todo--expanded]="expanded"
         *ngIf="totalCount > 0"
         (click)="stopPropagation($event)">
  <div class="thread-todo__summary"
       [class.thread-todo__summary--debug]="debugMode"
       [class.thread-todo__summary--edit-mode]="editMode"
       role="button"
       tabindex="0"
       [attr.aria-expanded]="expanded"
       (click)="toggleExpanded($event)"
       (keydown.enter)="toggleExpanded($event)"
       (keydown.space)="toggleExpanded($event)">
    <span class="thread-todo__title">To-do</span>
    <span class="thread-todo__count">{{ completedCount }}/{{ totalCount }}</span>
    <span class="thread-todo__debug-actions" *ngIf="debugMode">
      <button type="button"
              class="thread-todo__debug-action"
              [class.thread-todo__debug-action--active]="editMode"
              [attr.aria-pressed]="editMode"
              aria-label="Toggle todo edit mode"
              [title]="editMode ? 'Exit todo edit mode' : 'Edit to-do list'"
              (click)="onToggleEditMode($event)">
        <i class="fa-solid fa-pen" aria-hidden="true"></i>
      </button>
      <button *ngIf="editMode"
              type="button"
              class="thread-todo__debug-action thread-todo__debug-action--danger"
              aria-label="Delete todo list"
              title="Delete todo list"
              (click)="onResetTodoList($event)">
        <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
      </button>
    </span>
    <i class="fa-solid fa-chevron-down thread-todo__chevron" aria-hidden="true"></i>
  </div>

  <div class="thread-todo__body">
    <ol class="thread-todo__list">
      <li class="thread-todo__item"
          *ngFor="let item of visibleItems; trackBy: trackByTodoId"
          [class.thread-todo__item--active]="item.status === 'in_progress'"
          [class.thread-todo__item--done]="item.status === 'completed'"
          [class.thread-todo__item--blocked]="item.status === 'blocked'"
          [class.thread-todo__item--waiting]="item.status === 'waiting_for_user'"
          [class.thread-todo__item--editing]="isEditing(item)"
          [class.thread-todo__item--has-tooltip]="getTodoTooltip(item)"
          [uiTooltip]="isEditing(item) ? '' : getTodoTooltip(item)"
          uiTooltipPlacement="left-center"
          [uiTooltipDelay]="150">
        <span class="thread-todo__status" aria-hidden="true">
          <i *ngIf="getStatusIcon(item)" [class]="getStatusIcon(item)"></i>
        </span>
        <span class="thread-todo__copy">
          <span class="thread-todo__item-title">{{ item.title }}</span>
        </span>
        <span class="thread-todo__row-actions" *ngIf="debugMode && editMode && !isEditing(item)">
          <button type="button"
                  class="thread-todo__debug-action thread-todo__debug-action--row"
                  aria-label="Edit todo item"
                  title="Edit todo item"
                  (click)="onEditTodoItem(item, $event)">
            <i class="fa-solid fa-pen" aria-hidden="true"></i>
          </button>
        </span>

        <form class="thread-todo__edit-form"
              *ngIf="debugMode && editMode && isEditing(item)"
              (submit)="onSaveEdit(item, $event)"
              (click)="stopPropagation($event)">
          <input class="thread-todo__edit-input"
                 type="text"
                 name="todo-title-{{ item.id }}"
                 [(ngModel)]="editTitle"
                 aria-label="To-do title"
                 placeholder="Title">
          <textarea class="thread-todo__edit-input thread-todo__edit-input--notes"
                    name="todo-notes-{{ item.id }}"
                    [(ngModel)]="editNotes"
                    aria-label="To-do description"
                    placeholder="Description"></textarea>
          <select class="thread-todo__edit-input"
                  name="todo-status-{{ item.id }}"
                  [(ngModel)]="editStatus"
                  aria-label="To-do status">
            <option *ngFor="let option of statusOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
          <div class="thread-todo__edit-actions">
            <button type="button"
                    class="thread-todo__edit-button thread-todo__edit-button--danger"
                    aria-label="Delete todo item"
                    title="Delete todo item"
                    (click)="onDeleteTodoItem(item, $event)">
              Delete
            </button>
            <span class="thread-todo__edit-spacer"></span>
            <button type="button"
                    class="thread-todo__edit-button"
                    (click)="onCancelEdit($event)">
              Cancel
            </button>
            <button type="submit"
                    class="thread-todo__edit-button thread-todo__edit-button--save"
                    [disabled]="!editTitle.trim()">
              Save
            </button>
          </div>
        </form>
      </li>
    </ol>

    <div class="thread-todo__more" *ngIf="hasMoreItems">
      +{{ totalCount - visibleItems.length }} more
    </div>
  </div>
</section>
